import React from 'react';
import Navbar from '../components/Navbar';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Info } from 'lucide-react';

const LevelsPage = () => {
  const levels = [
    {
      name: 'זוגות Open',
      range: 'כל הרמות',
      description: 'תחרות זוגות פתוחה לכל הרמות. מתאים לשחקנים בכל רמה.',
      color: 'from-purple-500 to-pink-500'
    },
    {
      name: 'יחידים Open',
      range: 'רמה 3-4',
      description: 'תחרות יחידים לשחקנים ברמה גבוהה. משחק אינטנסיבי ותחרותי.',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      name: 'דרג א',
      range: 'רמה 4-5',
      description: 'שחקנים בעלי רמה גבוהה-בינונית. משחק טקטי וטכני מוצק.',
      color: 'from-green-500 to-emerald-500'
    },
    {
      name: 'דרג ב',
      range: 'רמה 5-6',
      description: 'שחקנים ברמה בינונית. שליטה במכות הבסיסיות והתחלת משחק טקטי.',
      color: 'from-yellow-500 to-orange-500'
    },
    {
      name: 'דרג ג',
      range: 'רמה 6-7',
      description: 'שחקנים מתחילים-בינוניים. מתאים למי שרוצה להתחיל לשחק בתחרויות.',
      color: 'from-red-500 to-rose-500'
    },
    {
      name: 'נשים',
      range: 'רמה 5-7',
      description: 'תחרות נשים בלבד. מתאים לכל הרמות ממתחילות עד מתקדמות.',
      color: 'from-pink-500 to-fuchsia-500'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      <Navbar />

      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Info className="w-12 h-12 text-blue-600" />
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900" data-testid="levels-title">
              הסבר רמות
            </h1>
          </div>
          <p className="text-lg text-gray-600">
            הבנת הקטגוריות והרמות השונות בתחרויות
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {levels.map((level, index) => (
            <Card key={index} className="card-hover overflow-hidden" data-testid={`level-card-${index}`}>
              <div className={`h-2 bg-gradient-to-r ${level.color}`}></div>
              <CardHeader>
                <CardTitle className="text-2xl">{level.name}</CardTitle>
                <CardDescription className="text-lg font-semibold text-blue-600">
                  {level.range}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-gray-700 leading-relaxed">{level.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Additional Info */}
        <Card className="mt-12 glass-effect" data-testid="additional-info-card">
          <CardHeader>
            <CardTitle className="text-2xl">מידע כללי</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4 text-gray-700 leading-relaxed">
            <div>
              <h3 className="font-bold text-xl mb-2">תחרויות יומיות:</h3>
              <ul className="list-disc list-inside space-y-2 mr-6">
                <li>תחרות שמתחילה ומסתיימת באותו היום</li>
                <li>עד 16 שחקנים בכל קטגוריה</li>
                <li>חלוקה ל-4 בתים של 4 שחקנים</li>
                <li>משחקים עד 2:2 סט מלא</li>
                <li>2 עולים מכל בית לנוקאאוט (רבע, חצי, גמר)</li>
              </ul>
            </div>
            <div>
              <h3 className="font-bold text-xl mb-2">תחרויות נוקאאוט ארוכות:</h3>
              <ul className="list-disc list-inside space-y-2 mr-6">
                <li>עד 32 שחקנים בכל קטגוריה</li>
                <li>שמינית גמר → רבע גמר → חצי גמר → גמר</li>
                <li>הטוב מ-3 מערכות (סט שלישי סופר טייברייק)</li>
                <li>ברקט נוקאאוט אינטראקטיבי באתר</li>
              </ul>
            </div>
            <div>
              <h3 className="font-bold text-xl mb-2">הרשמה ורשימת המתנה:</h3>
              <ul className="list-disc list-inside space-y-2 mr-6">
                <li>הרשמה אונליין בלחיצת כפתור</li>
                <li>רשימת המתנה אוטומטית אם התחרות מלאה</li>
                <li>הגרלה אוטומטית ברגע שהרשימה מתמלאת</li>
                <li>אפשרות לבטל הרשמה עד תחילת התחרות</li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default LevelsPage;
